import { useMemo } from 'react';
import { useGetUserMeetingStatisticsQuery } from '../api';
/**
 * Hook to get user meeting statistics for a project.
 *
 * @param projectId - Project ID to fetch statistics for.
 * @returns an object with user meeting statistics, loading state, error state and error object.
 */
export const useUserMeetingStatistics = (projectId) => {
    const { data: statistics, isLoading, isUninitialized, isError, error, } = useGetUserMeetingStatisticsQuery({ projectId });
    const isForbidden = isError &&
        typeof error === 'object' &&
        error !== null &&
        'status' in error &&
        error.status === 403;
    return useMemo(() => ({
        statistics,
        isLoading: isLoading || isUninitialized,
        isError: isError && !isForbidden,
        error: isForbidden ? null : error,
    }), [error, isError, isForbidden, isLoading, isUninitialized, statistics]);
};
